import React, { useState, useEffect } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { ServerPath } from '../../Constant';
import { toast } from 'react-toastify';
import { _axios } from '../../utils/axios';
// import axios from 'axios';

const EditChapter = ({ show, onHide, chapterData }) => {
    const containsInvalidCharacters = (text) => {
        // This regex pattern will detect emojis and many special unicode characters
        const emojiRegex = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/u;
        
        // Test if the text contains emojis or other invalid characters
        return emojiRegex.test(text);
      };
    const [chapterTitle, setChapterTitle] = useState('');
    const [chapterNumber, setChapterNumber] = useState('');
    const [chapterId, setChapterId] = useState('');
    const [creationDate, setCreationDate] = useState('');
    const [lastUpdate, setLastUpdate] = useState('');
    const [status, setStatus] = useState('New');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [chapterTitleMar, setChapterTitleMar] = useState('');
    const [chapterTitleHin, setChapterTitleHin] = useState('');
    const [chapterTitleGuj, setChapterTitleGuj] = useState('');

        // Helper function to safely format dates
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return 'N/A';
            
            return date.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            });
        } catch (error) {
            console.error("Error formatting date:", error);
            return 'N/A';
        }
    };

    useEffect(() => {
        if (chapterData) {
            console.log("Chapter data received:", chapterData); // Log incoming data
            
            // Check all possible date field names
            console.log("Date fields:", {
                created_at: chapterData.created_at,
                createdAt: chapterData.createdAt,
                created: chapterData.created,
                updated_at: chapterData.updated_at,
                updatedAt: chapterData.updatedAt,
                updated: chapterData.updated,
            });
            
            setChapterTitle(chapterData.title || '');
            setChapterTitleMar(chapterData.title_mar || '');
            setChapterTitleHin(chapterData.title_hin || '');
            setChapterTitleGuj(chapterData.title_guj || '');
            setChapterNumber(`Chapter - ${chapterData.sequence_number || ''}`);
            setChapterId(chapterData.chapter_id || '');
            setStatus(chapterData.status || 'New');
            
            // Use a helper function to safely format dates
            setCreationDate(formatDate(chapterData.created_at || chapterData.createdAt || chapterData.created));
            setLastUpdate(formatDate(chapterData.updated_at || chapterData.updatedAt || chapterData.updated || chapterData.created_at || chapterData.createdAt || chapterData.created));
        }
    }, [chapterData]);

    const containsAlphanumeric = (text) => {
        const alphanumericRegex = /[a-zA-Z0-9]/; // Matches any letter or number
        return alphanumericRegex.test(text);
      };

    const handleTitleChange = (e) => {
        const value = e.target.value;
        
        // Validate for emojis and special characters
        if (containsInvalidCharacters(value)) {
            toast.error("Please enter valid text. Emojis and unsupported symbols are not allowed.", {
                toastId: 'emoji-error' // Prevents duplicate toasts
            });
            return; // Don't update the state with invalid characters
        }
        
        // NEW VALIDATION: Check if title contains at least one alphanumeric character
        if (value.trim() !== '' && !containsAlphanumeric(value)) {
            toast.error("Please enter a valid Chapter Title using letters or numbers.", {
                toastId: 'alphanumeric-error'
            });
            return;
        }
        
        setChapterTitle(value);
    };
    
    const handleStatusChange = (e) => {
        setStatus(e.target.value);
    };

    const handleMultilingualTitleChange = (setter) => (e) => {
        const value = e.target.value;
        if (containsInvalidCharacters(value)) {
            toast.error("Please enter valid text. Emojis and unsupported symbols are not allowed.", { toastId: 'emoji-error' });
            return;
        }
        setter(value);
    };

    const handleSubmit = async () => {
        const titleValidations = [
            { value: chapterTitle, lang: 'English' },
            { value: chapterTitleMar, lang: 'Marathi' },
            { value: chapterTitleHin, lang: 'Hindi' },
            { value: chapterTitleGuj, lang: 'Gujarati' },
        ];
        for (const { value, lang } of titleValidations) {
            if (!value.trim()) {
                toast.error(`${lang} chapter title is required`);
                return;
            }
        }

        try {
            setIsSubmitting(true);

            // Create update data object
            const updateData = {
                chapter_id: chapterId,
                title: chapterTitle,
                title_mar: chapterTitleMar || null,
                title_hin: chapterTitleHin || null,
                title_guj: chapterTitleGuj || null,
            };
            
            // Update chapter status if it has changed
            await _axios.put(`${ServerPath}/chapter/status`, {
                chapter_id: chapterId,
                status: status
            });

            // Make API call
            const response = await _axios.put(`${ServerPath}/chapter/update`, updateData);

            if (response.data.success) {
                toast.success('Chapter has been successfully updated');
                
                // Get fresh chapter data after update
                try {
                    console.log("Fetching fresh chapter data after update");
                    const freshDataResponse = await _axios.get(`${ServerPath}/chapter/${chapterId}`);
                    console.log("Fresh chapter data response:", freshDataResponse.data);
                    
                    if (freshDataResponse.data.success) {
                        const updatedChapter = freshDataResponse.data.data;
                        console.log("Updated chapter data:", updatedChapter);
                        
                        // Update the state with fresh data
                        if (updatedChapter.updated_at) {
                            console.log("New updated_at date:", updatedChapter.updated_at);
                            const date = new Date(updatedChapter.updated_at);
                            setLastUpdate(date.toLocaleDateString('en-GB', {
                                day: '2-digit',
                                month: 'short', // Changed from 'MMM' to 'short'
                                year: 'numeric'
                            }));
                        }
                    }
                } catch (error) {
                    console.error('Error fetching updated chapter data:', error);
                }
                
                onHide();
            }
        } catch (error) {
            console.error('Error updating chapter:', error);
            toast.error(error.response?.data?.message || 'Failed to update chapter');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            className="edit-chapter-modal"
            size="xl"
        >
            <Modal.Header closeButton style={{ borderBottom: '1px solid #E2E8F0' }}>
                <Modal.Title>Edit Chapter</Modal.Title>
            </Modal.Header>

            <Modal.Body className="px-4 py-3">
                <div className="d-flex justify-content-between mb-4">
                    <div>
                        <span className="text-muted">Chapter ID - </span>
                        <span>{chapterId}</span>
                    </div>
                    <div>
                        <span className="text-muted">Record Creation Date - </span>
                        <span>{creationDate}</span>
                    </div>
                    <div>
                        <span className="text-muted">Last Updated Date -</span>
                        <span>{lastUpdate}</span>
                    </div>
                </div>

                <div className="mt-3">
                    <h6 className="text-primary mb-4" style={{ color: '#6366F1' }}>Chapter</h6>

                    <div className="row mb-3">
                        <div className="col-md-3">
                            <Form.Group>
                                <Form.Label style={{ fontWeight: '500' }}>Chapter Number</Form.Label>
                                <div className="form-control" style={{ border: '1px solid #E2E8F0', backgroundColor: '#f8f9fa', cursor: 'not-allowed' }}>
                                    {chapterNumber}
                                </div>
                            </Form.Group>
                        </div>
                        <div className="col-md-3">
                            <Form.Group>
                                <Form.Label style={{ fontWeight: '500' }}>
                                    Chapter Status <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Select
                                    value={status}
                                    onChange={handleStatusChange}
                                    style={{ border: '1px solid #E2E8F0', backgroundColor: 'white', height: '40px' }}
                                >
                                    <option value="New">New</option>
                                    <option value="Active">Active</option>
                                    <option value="Archived">Archived</option>
                                </Form.Select>
                            </Form.Group>
                        </div>
                    </div>

                    {/* Chapter Titles - 4 languages */}
                    <div className="row mb-3">
                        {[
                            { label: 'English', value: chapterTitle, onChange: handleTitleChange },
                            { label: 'Marathi', value: chapterTitleMar, onChange: handleMultilingualTitleChange(setChapterTitleMar) },
                            { label: 'Hindi', value: chapterTitleHin, onChange: handleMultilingualTitleChange(setChapterTitleHin) },
                            { label: 'Gujarati', value: chapterTitleGuj, onChange: handleMultilingualTitleChange(setChapterTitleGuj) },
                        ].map(lang => (
                            <div key={lang.label} className="col-3">
                                <Form.Group>
                                    <Form.Label style={{ fontWeight: '500', fontSize: '14px' }}>
                                        {lang.label} Title <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder={`Enter ${lang.label} title`}
                                        value={lang.value}
                                        onChange={lang.onChange}
                                        style={{ border: '1px solid #E2E8F0', backgroundColor: 'white' }}
                                    />
                                </Form.Group>
                            </div>
                        ))}
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer style={{ borderTop: '1px solid #E2E8F0', justifyContent: 'flex-end' }}>
                <Button
                    variant="primary"
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                    style={{ backgroundColor: '#6366F1', minWidth: '80px' }}
                >
                    Update
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditChapter;